import Mock from 'mockjs'

// 模拟延迟
Mock.setup({
  timeout: '200-600'
})

// 登录接口
Mock.mock('/api/login', 'post', (options) => {
  const { username, password } = JSON.parse(options.body)
  if (username === 'admin' && password === '123') {
    return {
      code: 200,
      message: '登录成功',
      data: {
        token: 'mock_token_' + Date.now(),
        user: {
          username: 'admin',
          name: '管理员'
        }
      }
    }
  }
  return {
    code: 401,
    message: '用户名或密码错误'
  }
})

// 管理员列表
Mock.mock(/\/api\/admin\/list/, 'get', () => {
  return {
    code: 200,
    data: {
      list: Mock.mock({
        'list|10-20': [{
          'id|+1': 1,
          'username': '@word(5,10)',
          'name': '@cname',
          email() {
            return `${Mock.Random.word(5, 10)}@admin.demo`
          },
          'phone': /^1[3-9]\d{9}$/,
          'role': '@pick(["超级管理员", "管理员", "编辑"])',
          'status|1': ['正常', '禁用'],
          'createTime': '@datetime("yyyy-MM-dd HH:mm:ss")'
        }]
      }).list,
      total: 20
    }
  }
})

// 角色列表
Mock.mock(/\/api\/role\/list/, 'get', () => {
  return {
    code: 200,
    data: {
      list: Mock.mock({
        'list|8-15': [{
          'id|+1': 1,
          'name': '@pick(["超级管理员", "系统管理员", "内容管理员", "运营管理员", "客服管理员"])',
          'code': '@pick(["super_admin", "system_admin", "content_admin", "operation_admin", "service_admin"])',
          'description': '@pick(["拥有全局配置和用户权限的最高权限", "负责系统稳定性、配置与账号管理", "负责音频内容、分类与标签的管理与审核", "负责活动配置、订单策略与运营数据", "负责用户反馈、通知推送与客服沟通"])',
          'status|1': ['启用', '禁用'],
          'createTime': '@datetime("yyyy-MM-dd HH:mm:ss")'
        }]
      }).list,
      total: 15
    }
  }
})

// 权限列表
Mock.mock(/\/api\/permission\/list/, 'get', () => {
  const permissions = [
    { name: '用户管理', code: 'user:view', type: '菜单', path: '/user' },
    { name: '用户查看', code: 'user:list', type: '按钮', path: '' },
    { name: '用户编辑', code: 'user:edit', type: '按钮', path: '' },
    { name: '订单管理', code: 'order:view', type: '菜单', path: '/order' },
    { name: '订单查看', code: 'order:list', type: '按钮', path: '' },
    { name: '订单编辑', code: 'order:edit', type: '按钮', path: '' },
    { name: '音频管理', code: 'audio:view', type: '菜单', path: '/audio' },
    { name: '音频查看', code: 'audio:list', type: '按钮', path: '' },
    { name: '音频编辑', code: 'audio:edit', type: '按钮', path: '' },
    { name: '通知管理', code: 'notification:view', type: '菜单', path: '/notification' },
    { name: '通知查看', code: 'notification:list', type: '按钮', path: '' },
    { name: '通知编辑', code: 'notification:edit', type: '按钮', path: '' },
    { name: '数据统计', code: 'statistics:view', type: '菜单', path: '/statistics' },
    { name: '系统配置', code: 'config:view', type: '菜单', path: '/config' }
  ]
  return {
    code: 200,
    data: {
      list: permissions.map((item, index) => ({
        id: index + 1,
        ...item,
        parentId: item.type === '按钮' ? Math.floor(Math.random() * 5) + 1 : 0,
        sort: index + 1,
        createTime: Mock.Random.datetime('yyyy-MM-dd HH:mm:ss')
      })),
      total: permissions.length
    }
  }
})

// 用户列表
Mock.mock(/\/api\/user\/list/, 'get', (options) => {
  return {
    code: 200,
    data: {
      list: Mock.mock({
        'list|20-30': [{
          'id|+1': 1,
          'username': '@word(5,10)',
          'name': '@cname',
          'email': '@email',
          'phone': /^1[3-9]\d{9}$/,
          'subscription|1': ['已订阅', '未订阅', '已过期'],
          'subscriptionTime': '@datetime("yyyy-MM-dd HH:mm:ss")',
          'country|1': ['中国', '美国', '日本', '英国'],
          'deviceCount|1-5': 1,
          'createTime': '@datetime("yyyy-MM-dd HH:mm:ss")'
        }]
      }).list,
      total: 30
    }
  }
})

// 订单列表
Mock.mock(/\/api\/order\/list/, 'get', () => {
  return {
    code: 200,
    data: {
      list: Mock.mock({
        'list|30-50': [{
          'id|+1': 1,
          'orderNo': 'ORD' + '@string("number", 10)',
          'userId|1-100': 1,
          'userName': '@cname',
          'userPhone': /^1[3-9]\d{9}$/,
          'userEmail': '@email',
          'amount|100-1000': 100,
          'paymentMethod|1': ['Apple Pay', 'PayPal'],
          'status|1': ['待支付', '已支付', '已取消', '已退款'],
          'createTime': '@datetime("yyyy-MM-dd HH:mm:ss")'
        }]
      }).list,
      total: 50
    }
  }
})

// 音频分类列表
Mock.mock(/\/api\/audio\/category\/list/, 'get', () => {
  return {
    code: 200,
    data: {
      list: [
        { id: 1, name: 'Ambience', type: 'Recommended', createTime: '2024-01-01' },
        { id: 2, name: 'Ambience', type: 'Personalized', createTime: '2024-01-01' },
        { id: 3, name: 'Nature', type: 'Recommended', createTime: '2024-01-02' },
        { id: 4, name: 'Urban', type: 'Recommended', createTime: '2024-01-03' }
      ],
      total: 4
    }
  }
})

// 音频元素列表
Mock.mock(/\/api\/audio\/element\/list/, 'get', () => {
  const elements = [
    { name: '风', category: '天气', description: '轻柔的风声', sort: 1 },
    { name: '大风', category: '天气', description: '强烈的风声', sort: 2 },
    { name: '雨', category: '天气', description: '小雨声', sort: 3 },
    { name: '暴雨', category: '天气', description: '大雨声', sort: 4 },
    { name: '海浪', category: '自然', description: '海浪拍打声', sort: 5 },
    { name: '溪流', category: '自然', description: '溪水流动声', sort: 6 },
    { name: '森林', category: '自然', description: '森林环境音', sort: 7 },
    { name: '鸟鸣', category: '自然', description: '鸟叫声', sort: 8 },
    { name: '城市', category: '城市', description: '城市环境音', sort: 9 },
    { name: '咖啡厅', category: '环境', description: '咖啡厅环境音', sort: 10 },
    { name: '图书馆', category: '环境', description: '图书馆安静环境', sort: 11 },
    { name: '篝火', category: '自然', description: '篝火燃烧声', sort: 12 }
  ]
  return {
    code: 200,
    data: {
      list: elements.map((item, index) => ({
        id: index + 1,
        ...item,
        status: '启用',
        createTime: Mock.Random.datetime('yyyy-MM-dd HH:mm:ss')
      })),
      total: elements.length
    }
  }
})

// AI生成的音频列表
Mock.mock(/\/api\/audio\/ai-generated\/list/, 'get', () => {
  const elements = ['风', '大风', '雨', '暴雨', '海浪', '溪流', '森林', '鸟鸣', '城市']
  return {
    code: 200,
    data: {
      list: Mock.mock({
        'list|30-50': [{
          'id|+1': 1,
          'image': 'https://via.placeholder.com/200?text=AI' + '@pick(["A", "B", "C", "D"])',
          'elements': function() {
            const count = Mock.Random.integer(1, 3)
            const selected = []
            for (let i = 0; i < count; i++) {
              const el = Mock.Random.pick(elements)
              if (!selected.includes(el)) {
                selected.push(el)
              }
            }
            return selected
          },
          'url': 'https://audio.example.com/ai-generated/' + '@word(10) + ".mp3"',
          'duration|180-3600': 180,
          'playCount|0-10000': 0,
          'status|1': ['上架', '下架'],
          'createTime': '@datetime("yyyy-MM-dd HH:mm:ss")'
        }]
      }).list,
      total: 50
    }
  }
})

// 音频列表
Mock.mock(/\/api\/audio\/list/, 'get', () => {
  return {
    code: 200,
    data: {
      list: Mock.mock({
        'list|20-30': [{
          'id|+1': 1,
          'name': '@pick(["雨声", "海浪", "森林", "城市", "风声", "鸟鸣", "溪流", "篝火", "咖啡厅", "图书馆"])' + '@pick(["白噪音", "环境音", "自然音"])',
          'categoryId|1-4': 1,
          'categoryName': '@pick(["Ambience", "Nature", "Urban"])',
          'type|1': ['Recommended', 'Personalized'],
          'url': 'https://audio.example.com/audio/' + '@word(10) + ".mp3"',
          'icon': 'https://via.placeholder.com/100?text=' + '@pick(["A", "B", "C", "D"])',
          'duration|180-3600': 180,
          'playCount|100-50000': 100,
          'status|1': ['上架', '下架'],
          'createTime': '@datetime("yyyy-MM-dd HH:mm:ss")'
        }]
      }).list,
      total: 30
    }
  }
})

// 用户收藏音频
Mock.mock(/\/api\/audio\/favorite/, 'get', () => {
  return {
    code: 200,
    data: {
      list: Mock.mock({
        'list|15-25': [{
          'id|+1': 1,
          'userId|1-100': 1,
          'nickname': '@cname',
          'phone': /^1[3-9]\d{9}$/,
          'email': '@email',
          'audioId|1-30': 1,
          'audioName': '@pick(["雨声白噪音", "海浪环境音", "森林自然音", "城市白噪音", "风声环境音"])',
          'audioIcon': 'https://via.placeholder.com/100?text=Audio',
          'favoriteTime': '@datetime("yyyy-MM-dd HH:mm:ss")'
        }]
      }).list,
      total: 25
    }
  }
})

// 音频生成日志
Mock.mock(/\/api\/audio\/log/, 'get', () => {
  return {
    code: 200,
    data: {
      list: Mock.mock({
        'list|30-50': [{
          'id|+1': 1,
          'userId|1-100': 1,
          'nickname': '@cname',
          'phone': /^1[3-9]\d{9}$/,
          'email': '@email',
          'audioText': '@pick(["我想要一些雨声来帮助我放松", "需要海浪声来帮助睡眠", "播放森林的自然声音", "给我一些城市白噪音", "想要风声来帮助专注工作"])',
          'intent': '@pick(["放松", "专注", "睡眠", "工作"])',
          'matchedElements': '@pick(["雨声", "海浪", "森林", "城市", "风声"])',
          'audioId|1-30': 1,
          'createTime': '@datetime("yyyy-MM-dd HH:mm:ss")'
        }]
      }).list,
      total: 50
    }
  }
})

// 通知列表
Mock.mock(/\/api\/notification\/list/, 'get', () => {
  return {
    code: 200,
    data: {
      list: Mock.mock({
        'list|10-20': [{
          'id|+1': 1,
          'title': '@pick(["系统维护通知", "新功能上线", "版本更新公告", "活动优惠通知", "服务升级通知"])',
          'content': '@cparagraph(2,5)',
          'type|1': ['通知', '活动', '更新'],
          'category': '@pick(["系统通知", "活动通知", "版本更新"])',
          'status|1': ['已发布', '草稿', '已下架'],
          'createTime': '@datetime("yyyy-MM-dd HH:mm:ss")'
        }]
      }).list,
      total: 20
    }
  }
})

// 统计数据
Mock.mock(/\/api\/statistics\/data/, 'get', () => {
  return {
    code: 200,
    data: {
      userCount: 12580,
      activeUserCount: 3250,
      onlineUserCount: 850,
      totalPlayDuration: 1250000,
      avgPlayDuration: 99.3,
      timeDistribution: Array.from({ length: 24 }, (_, i) => ({
        hour: i,
        count: Math.floor(Math.random() * 500) + 100
      })),
      audioGenerationFrequency: Array.from({ length: 7 }, (_, i) => ({
        date: `2024-01-${i + 1}`,
        count: Math.floor(Math.random() * 200) + 50
      })),
      userDemand: [
        { element: '雨声', count: 1250 },
        { element: '海浪', count: 980 },
        { element: '森林', count: 750 },
        { element: '城市', count: 620 },
        { element: '风声', count: 450 }
      ]
    }
  }
})

export default Mock
